import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Cycle = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Cycle" {...props}>
    <path d="M18 4C20.7614 4 23 6.23858 23 9V15C23 17.7614 20.7614 20 18 20H14.4287L15.7109 21.2969C16.0992 21.6896 16.0957 22.3226 15.7031 22.7109C15.3104 23.0992 14.6774 23.0957 14.2891 22.7031L11.2891 19.668L11.2227 19.5947C11.078 19.416 10.9988 19.1919 11 18.96C11.0015 18.6947 11.1082 18.4404 11.2969 18.2539L14.2969 15.2891C14.6896 14.9009 15.3227 14.9043 15.7109 15.2969C16.0991 15.6896 16.0957 16.3227 15.7031 16.7109L14.3994 18H18C19.6569 18 21 16.6569 21 15V9C21 7.34315 19.6569 6 18 6H6C4.34315 6 3 7.34315 3 9V15C3 16.6569 4.34315 18 6 18H8C8.55228 18 9 18.4477 9 19C9 19.5523 8.55228 20 8 20H6C3.23858 20 1 17.7614 1 15V9C1 6.23858 3.23858 4 6 4H18Z" fill="#000" />
  </StyledIcon>
));

Cycle.displayName = 'Cycle';

export { Cycle };
